<div class="page">
  <div class="header">
    <button mat-icon-button type="button" (click)="cerrar()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div>
      <h1>Resumen de estudios</h1>

      <p>
        {{ paciente.nombre }}
        {{ paciente.apellido }}
        {{ paciente.segundoApellido }}
      </p>
    </div>
  </div>

  <div class="body">
    @if (cargando) {
      <p class="sin-datos">Cargando información...</p>
    } @else if (analisis.length === 0) {
      <div class="sin-datos">
        <mat-icon class="material-symbols-outlined"> document_search </mat-icon>

        <h2>Este paciente no tiene estudios registrados</h2>
      </div>
    } @else {
      @for (item of analisis; track item.id) {
        <div class="estudio-card">
          <div class="estudio-header">
            <mat-icon> science </mat-icon>

            <strong> {{ item.archivo.nombreOriginal }} </strong>
          </div>

          <div class="estudio-info">
            <span class="fecha-estudio">
              <mat-icon>calendar_month</mat-icon>
              {{ obtenerFecha(item.fecha) }}
            </span>

            <p class="resumen">{{ item.hallazgos }}</p>
          </div>
          <div class="acciones-receta">
            <button
              mat-flat-button
              class="add-boton"
              type="button"
              (click)="descargarArchivo(item)"
            >
              <mat-icon> attach_file </mat-icon>
              Ver archivo
            </button>
          </div>
        </div>
      }
    }
  </div>
</div>
